import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from '../../../shared/service/notification.service';
import { LoaderService } from '../../../shared/loader/loader.service';
import { LoginService } from './shared/login.service';
import { User, IUser } from './shared/user.model';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { SessionInfo } from '../../../shared/session/SessionInfo';
import { CustomValidators, RegularExpression, RegularExpressionMessage } from '../../../shared/validation/customvalidation';
import { Rol } from '../Roles/shared/rol.model';
import { Session } from './shared/session.model';
import { EmpresaService } from '../empresa/shared/empresa.service';
import { Empresa } from '../empresa/shared/empresa.model';
import { ConfiguracionInfo } from 'src/app/shared/configuracion/configuracionInfo';
import { ConfiguracionService } from '../configuracion/shared/configuracion.service';
import { Configuracion } from '../configuracion/shared/configuracion.model';
import { NivelAccesoService } from '../nivelAcceso/shared/nivel-acceso.service';
import { NivelAcceso } from '../nivelAcceso/shared/nivel-acceso.model';
import { EntidadService } from '../entidad/shared/entidad.service';
import { Entidad } from '../entidad/shared/entidad.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  private user: IUser;
  msgInternalErrorLogin: string;
  msgInternalErrorRol: string;
  msgInternalErrorConfiguracion: string;
  formGrupLogin: FormGroup;
  usernameMaxLength: number;
  passwordMaxLength: number;
  passwordMinLength: number;
  landingPage: string;
  obligatorioMsg: string;
  maxLengthMsg: string;
  usernamePatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  versionAngular: string;
  versionAppWeb: string;
  viewPassword: boolean = false;
  isBtnActive: boolean;
  session: Session;
  configuracion: Configuracion;
  year: number = new Date().getFullYear();
  empresas: Empresa[] = [];
  nivelesAcceso: NivelAcceso[] = [];
  entidades: Entidad[] = [];
  roles: Rol[] = [];

  @ViewChild('showhideinput') input;

  constructor(
    private loginService: LoginService, private router: Router, private notificationService: NotificationService,
    private loaderService: LoaderService, private empresaService: EmpresaService,
    private configuracionService: ConfiguracionService, public fb: FormBuilder, private sessionInfo: SessionInfo,
    private configuracionInfo: ConfiguracionInfo, private nivelAccesoService: NivelAccesoService, private entidadService: EntidadService
  ) { }

  ngOnInit() {
    this.obligatorioMsg = 'Campo Obligatorio';
    this.maxLengthMsg = 'El tamaño de la contraseña deber ser de ';
    this.msgInternalErrorLogin = 'Error del servicio al validar login';
    this.msgInternalErrorRol = 'Error del servicio al obtener la lista de roles';
    this.msgInternalErrorConfiguracion = 'Error del servicio al obtener configuración';
    this.landingPage = 'landingAplicacion';
    this.usernameMaxLength = 20;
    this.passwordMaxLength = 10;
    this.passwordMinLength = 6;
    this.user = new User("", "", 0, 0, 0, 0, 0, 0);
    this.isBtnActive = true;
    this.versionAngular = environment.versionAngular;
    this.versionAppWeb = environment.versionAppWeb;
    this.setValuesFormBuilder();
  }

  setValuesFormBuilder() {
    this.formGrupLogin = this.fb.group({
      userName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.usernameMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ]),],
      password: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.passwordMaxLength),
        Validators.minLength(this.passwordMinLength)
      ]),],
      empresaID: [],
      idNivelAcceso: [],
      idEntidad: [],
      rolID: [],
    });
  }

  onBlurUserName() {
    this.user.userName = this.formGrupLogin.get('userName').value;
    this.getEmpresa();
  }

  getEmpresa() {
    this.loaderService.show();
    this.empresaService.listarEmpresaPorUsuario(this.user.userName, 0).subscribe(res => {
      this.empresas = res;
      if (this.empresas.length >= 1) {
        this.formGrupLogin.get('empresaID').setValue(this.empresas[0].ID);
        this.listarNivelAccesoPor();
        this.getConfiguracion();
      }
    },
      error => {
        this.notificationService.error("Error del servicio al obtener la lista de empresas");
        this.isBtnActive = true;
        throw error;
      },
      () => {
        this.isBtnActive = true;
        this.loaderService.hide();
      });
  }

  listarNivelAccesoPor() {
    this.loaderService.show();
    let empresaID = this.formGrupLogin.get('empresaID').value;
    this.nivelAccesoService.listarNivelAccesoPor(this.user.userName, empresaID)
      .subscribe(res => {
        this.nivelesAcceso = res;
        if (this.nivelesAcceso.length >= 1) {
          this.formGrupLogin.get('idNivelAcceso').setValue(this.nivelesAcceso[0].id);
          this.listarEntidad();
        }
      },
        error => {
          this.notificationService.error("Error del servicio al obtener la lista de niveles de acceso");
          this.isBtnActive = true;
          throw error;
        },
        () => {
          this.isBtnActive = true;
          this.loaderService.hide();
        });
  }

  listarEntidad() {
    this.loaderService.show();
    let empresaID = this.formGrupLogin.get('empresaID').value;
    let idNivelAcceso = this.formGrupLogin.get('idNivelAcceso').value;
    this.entidadService.listByAcceso(this.user.userName, empresaID, idNivelAcceso)
      .subscribe(res => {
        this.entidades = res;
        if (this.entidades.length >= 1) {
          this.formGrupLogin.get('idEntidad').setValue(this.entidades[0].id);
          this.getRol();
        }
      },
        error => {
          this.notificationService.error("Error del servicio al obtener la lista de entidades");
          this.isBtnActive = true;
          throw error;
        },
        () => {
          this.isBtnActive = true;
          this.loaderService.hide();
        });
  }

  getRol() {
    this.loaderService.show();
    let empresaID = this.formGrupLogin.get('empresaID').value;
    let idNivelAcceso = this.formGrupLogin.get('idNivelAcceso').value;
    let idEntidad = this.formGrupLogin.get('idEntidad').value;
    this.loginService.listarRolePorAcceso(this.user.userName, empresaID, idNivelAcceso, idEntidad)
      .subscribe(res => {
        this.roles = res;
        if (this.roles.length >= 1) {
          this.formGrupLogin.get('rolID').setValue(this.roles[0].ID);
        }
      },
        error => {
          this.notificationService.error(this.msgInternalErrorRol);
          this.isBtnActive = true;
          throw error;
        },
        () => {
          this.isBtnActive = true;
          this.loaderService.hide();
        });
  }

  onChangeEmpresa() {
    this.listarNivelAccesoPor();
    this.getConfiguracion();
  }

  onChangeNivelAcceso() {
    this.listarEntidad();
  }

  onChangeEntidad() {
    this.getRol();
  }

  mostrarContrasena(e: any) {
    this.viewPassword = !this.viewPassword
    if (this.viewPassword) {
      this.input.nativeElement.type = 'text';
      e.nativeElement;
    } else {
      this.input.nativeElement.type = 'password';
    }
  }

  formGrupLoginSubmit(event) {
    if (!this.formGrupLogin.valid)
      return;
    this.user.userName = event.value.userName;
    this.user.password = event.value.password;
    this.user.empresaID = event.value.empresaID;
    this.user.idNivelAcceso = event.value.idNivelAcceso;
    this.user.idEntidad = event.value.idEntidad;
    this.user.rolID = event.value.rolID;
    this.isBtnActive = false;
    this.validateLogin();
  }

  validateLogin() {
    this.loaderService.show();
    this.user.aplicacionID = environment.aplicacionID;
    this.loginService.validateLogin(this.user).subscribe(res => {
      if (res.Status == 1) {
        this.session = res.Data;
        let stringifyValue: any = JSON.stringify(this.session);
        this.sessionInfo.setAudit(stringifyValue);
        this.configuracionInfo.setConfiguracion(JSON.stringify(this.configuracion));
        this.router.navigate([this.landingPage]);
      } else {
        this.notificationService.warning(res.Message.map((e) => e.trim()).join('\n'));
      }
    },
      error => {
        this.notificationService.error(this.msgInternalErrorLogin);
        this.isBtnActive = true;
        throw error;
      },
      () => {
        this.isBtnActive = true;
        this.loaderService.hide();
      });
  }

  getConfiguracion() {
    this.loaderService.show();
    let empresaID = this.formGrupLogin.get('empresaID').value;
    this.configuracionService.obtenerConfiguracion(empresaID).subscribe(res => {
      this.configuracion = res;
    },
      error => {
        this.notificationService.error(this.msgInternalErrorConfiguracion);
        this.isBtnActive = true;
        throw error;
      },
      () => {
        this.isBtnActive = true;
        this.loaderService.hide();
      });
  }
}
